// Mobile Drawer Menu functionality
document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('lp-mobile-drawer');
    const overlay = document.getElementById('lp-drawer-overlay');
    const toggleBtn = document.getElementById('lp-drawer-toggle');
    const closeBtn = document.getElementById('lp-drawer-close');
    const drawerLinks = document.querySelectorAll('.lp-drawer-nav a');

    console.log('Drawer elements found:', { drawer: !!drawer, overlay: !!overlay, toggleBtn: !!toggleBtn });

    // Open drawer
    const openDrawer = () => {
        console.log('Opening drawer');
        if (drawer && overlay) {
            drawer.classList.add('active');
            overlay.classList.add('active');
            document.body.classList.add('drawer-open');
        }
    };

    // Close drawer
    const closeDrawer = () => {
        console.log('Closing drawer');
        if (drawer && overlay) {
            drawer.classList.remove('active');
            overlay.classList.remove('active');
            document.body.classList.remove('drawer-open');
        }
    };

    // Toggle drawer when hamburger is clicked
    if (toggleBtn) {
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openDrawer();
        });
    }

    // Close drawer when close button is clicked
    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            closeDrawer();
        });
    }

    // Close drawer when overlay is clicked
    if (overlay) {
        overlay.addEventListener('click', (e) => {
            console.log('Overlay clicked!');
            e.preventDefault();
            e.stopPropagation();
            closeDrawer();
        });
        
        // Also add touch event for mobile
        overlay.addEventListener('touchstart', (e) => {
            console.log('Overlay touched!');
            e.preventDefault();
            closeDrawer();
        }, { passive: false });
    }

    // Close drawer when a link is clicked
    drawerLinks.forEach(link => {
        link.addEventListener('click', () => {
            setTimeout(closeDrawer, 200); // Small delay for better UX
        });
    });

    // Close drawer on ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) {
            closeDrawer();
        }
    });
});

// Reviews Slider functionality
document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.lp-reviews .lp-slider-wrapper');
    if (!slider) return;

    const track = slider.querySelector('.lp-slider-track');
    const originalSlides = Array.from(slider.querySelectorAll('.lp-slide'));
    const prevButton = document.querySelector('.lp-reviews .slider-button-prev');
    const nextButton = document.querySelector('.lp-reviews .slider-button-next');
    const mobilePrevButton = document.querySelector('.lp-reviews .lp-mobile-nav-prev');
    const mobileNextButton = document.querySelector('.lp-reviews .lp-mobile-nav-next');
    const dots = document.querySelectorAll('.lp-reviews .lp-dot');

    let currentIndex = 0;
    const totalSlides = originalSlides.length;
    let isTransitioning = false;
    
    // Touch/Mouse drag variables
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTransform = 0;

    // Calculate how many slides to show based on screen width
    const getSlidesToShow = () => {
        return window.innerWidth > 768 ? 2 : 1;
    };

    const updateSlider = (animate = true) => {
        const allSlides = track.querySelectorAll('.lp-slide');
        const slideWidth = allSlides[0].offsetWidth;
        // Get the actual gap from computed styles
        const computedStyle = window.getComputedStyle(track);
        const gap = parseInt(computedStyle.gap) || 0;
        const offset = currentIndex * (slideWidth + gap);

        if (!animate) {
            track.style.transition = 'none';
        } else {
            track.style.transition = 'transform 0.4s ease-in-out';
        }

        track.style.transform = `translateX(-${offset}px)`;

        // Update dots based on actual position
        dots.forEach((dot, index) => {
            dot.classList.toggle('lp-dot-active', index === currentIndex);
        });

        // Disable buttons at boundaries
        const slidesToShow = getSlidesToShow();
        const maxIndex = Math.max(0, totalSlides - slidesToShow);
        if (prevButton) prevButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex >= maxIndex;
        if (mobilePrevButton) mobilePrevButton.disabled = currentIndex === 0;
        if (mobileNextButton) mobileNextButton.disabled = currentIndex >= maxIndex;
    };

    const navigate = (direction) => {
        if (isTransitioning) return;
        
        const slidesToShow = getSlidesToShow();
        const maxIndex = Math.max(0, totalSlides - slidesToShow);
        
        // Prevent navigation beyond boundaries
        if (direction === 'next' && currentIndex >= maxIndex) return;
        if (direction === 'prev' && currentIndex === 0) return;
        
        isTransitioning = true;

        if (direction === 'next') {
            currentIndex++;
            updateSlider(true);
            setTimeout(() => {
                isTransitioning = false;
            }, 400);
        } else if (direction === 'prev') {
            currentIndex--;
            updateSlider(true);
            setTimeout(() => {
                isTransitioning = false;
            }, 400);
        }
    };

    // Desktop button event listeners
    if (prevButton) prevButton.addEventListener('click', () => {
        navigate('prev');
    });
    if (nextButton) nextButton.addEventListener('click', () => {
        navigate('next');
    });

    // Mobile button event listeners
    if (mobilePrevButton) mobilePrevButton.addEventListener('click', () => {
        navigate('prev');
    });
    if (mobileNextButton) mobileNextButton.addEventListener('click', () => {
        navigate('next');
    });

    // Dot navigation
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            if (isTransitioning) return;
            isTransitioning = true;
            currentIndex = index;
            updateSlider(true);
            setTimeout(() => {
                isTransitioning = false;
            }, 400);
        });
    });

    // Touch/Swipe functionality for mobile
    const handleTouchStart = (e) => {
        if (isTransitioning) return;
        startX = e.touches[0].clientX;
        isDragging = true;
        track.style.transition = 'none';
        
        const allSlides = track.querySelectorAll('.lp-slide');
        const slideWidth = allSlides[0].offsetWidth;
        const computedStyle = window.getComputedStyle(track);
        const gap = parseInt(computedStyle.gap) || 0;
        startTransform = currentIndex * (slideWidth + gap);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        track.style.transform = `translateX(-${startTransform - diff}px)`;
    };

    const handleTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        
        const diff = currentX - startX;
        const threshold = 50; // Minimum distance to trigger slide change
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                navigate('prev');
            } else {
                navigate('next');
            }
        } else {
            updateSlider(true);
        }
        
        currentX = 0;
    };

    // Mouse drag functionality for desktop
    const handleMouseDown = (e) => {
        if (isTransitioning) return;
        startX = e.clientX;
        isDragging = true;
        track.style.cursor = 'grabbing';
        track.style.transition = 'none';
        
        const allSlides = track.querySelectorAll('.lp-slide');
        const slideWidth = allSlides[0].offsetWidth;
        const computedStyle = window.getComputedStyle(track);
        const gap = parseInt(computedStyle.gap) || 0;
        startTransform = currentIndex * (slideWidth + gap);
        
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
        const diff = currentX - startX;
        track.style.transform = `translateX(-${startTransform - diff}px)`;
    };

    const handleMouseUp = () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor = 'grab';
        
        const diff = currentX - startX;
        const threshold = 50; // Minimum distance to trigger slide change
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                navigate('prev');
            } else {
                navigate('next');
            }
        } else {
            updateSlider(true);
        }
        
        currentX = 0;
    };

    const handleMouseLeave = () => {
        if (isDragging) {
            handleMouseUp();
        }
    };

    // Add touch event listeners
    track.addEventListener('touchstart', handleTouchStart, { passive: true });
    track.addEventListener('touchmove', handleTouchMove, { passive: true });
    track.addEventListener('touchend', handleTouchEnd);

    // Add mouse event listeners
    track.addEventListener('mousedown', handleMouseDown);
    track.addEventListener('mousemove', handleMouseMove);
    track.addEventListener('mouseup', handleMouseUp);
    track.addEventListener('mouseleave', handleMouseLeave);

    // Set cursor style
    track.style.cursor = 'grab';

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Ensure currentIndex doesn't exceed maxIndex after resize
            const slidesToShow = getSlidesToShow();
            const maxIndex = Math.max(0, totalSlides - slidesToShow);
            if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
            }
            updateSlider(false);
        }, 150);
    });

    // Initial update
    updateSlider(false);
});

// Update cart count bubble
function updateCartBubble() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartBtn = document.getElementById('lp-cart-btn');
            if (!cartBtn) return;
            
            let bubble = cartBtn.querySelector('.cart-count-bubble');
            
            if (cart.item_count > 0) {
                if (!bubble) {
                    bubble = document.createElement('div');
                    bubble.className = 'cart-count-bubble';
                    cartBtn.appendChild(bubble);
                }
                
                // Update the bubble content with count
                let content = '';
                if (cart.item_count < 100) {
                    content = `<span aria-hidden="true">${cart.item_count}</span>`;
                }
                content += `<span class="visually-hidden">${cart.item_count} item${cart.item_count !== 1 ? 's' : ''} in cart</span>`;
                bubble.innerHTML = content;
                
                console.log('Cart bubble updated:', cart.item_count);
            } else {
                if (bubble) {
                    bubble.remove();
                    console.log('Cart bubble removed - cart is empty');
                }
            }
        })
        .catch(error => {
            console.error('Error updating cart bubble:', error);
        });
}

// Make updateCartBubble globally accessible
window.updateCartBubble = updateCartBubble;

// Intercept fetch requests to cart/add.js
const originalFetch = window.fetch;
window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
        // Check if it's a cart add request
        if (args[0] && (
            args[0].includes('/cart/add') || 
            args[0].includes('/cart/update') ||
            args[0].includes('/cart/change')
        )) {
            console.log('Cart modification detected, updating bubble...');
            setTimeout(updateCartBubble, 100);
        }
        return response;
    });
};

// Listen for cart updates
document.addEventListener('DOMContentLoaded', function() {
    // Initial update on page load
    updateCartBubble();
    
    // Listen for various Shopify cart events
    document.addEventListener('cart:updated', updateCartBubble);
    document.addEventListener('cart:refresh', updateCartBubble);
    document.addEventListener('cart-update', updateCartBubble);
    
    // Listen for product form submission (add to cart)
    document.addEventListener('product:added-to-cart', updateCartBubble);
    
    // Listen for cart drawer changes
    document.addEventListener('cart-drawer:open', updateCartBubble);
    document.addEventListener('cart-drawer:close', updateCartBubble);
    
    // Observe changes to cart-drawer element if it exists
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver(updateCartBubble);
        observer.observe(cartDrawer, { 
            childList: true, 
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'open']
        });
    }
    
    // Also poll for changes every 2 seconds as a backup
    setInterval(updateCartBubble, 2000);
});

document.addEventListener('DOMContentLoaded', function() {
    const lpCartLinks = document.querySelectorAll('.lp-cart-link');
    if (!lpCartLinks.length) return;

    lpCartLinks.forEach((link) => {
        link.addEventListener('click', function(e) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
                e.preventDefault();
                cartDrawer.open(link);
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
        const slider = document.querySelector('.lp-reviews .lp-slider-wrapper');
        if (!slider) return;

        const track = slider.querySelector('.lp-slider-track');
        const originalSlides = Array.from(slider.querySelectorAll('.lp-slide'));
        const prevButton = document.querySelector('.lp-reviews .slider-button-prev');
        const nextButton = document.querySelector('.lp-reviews .slider-button-next');
        const mobilePrevButton = document.querySelector('.lp-reviews .lp-mobile-nav-prev');
        const mobileNextButton = document.querySelector('.lp-reviews .lp-mobile-nav-next');
        const dots = document.querySelectorAll('.lp-reviews .lp-dot');

        let currentIndex = 0;
        const totalSlides = originalSlides.length;
        let isTransitioning = false;
        
        // Touch/Mouse drag variables
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTransform = 0;

        // Calculate how many slides to show based on screen width
        const getSlidesToShow = () => {
            return window.innerWidth > 768 ? 2 : 1;
        };

        const updateSlider = (animate = true) => {
            const allSlides = track.querySelectorAll('.lp-slide');
            const slideWidth = allSlides[0].offsetWidth;
            // Get the actual gap from computed styles
            const computedStyle = window.getComputedStyle(track);
            const gap = parseInt(computedStyle.gap) || 0;
            const offset = currentIndex * (slideWidth + gap);

            if (!animate) {
                track.style.transition = 'none';
            } else {
                track.style.transition = 'transform 0.4s ease-in-out';
            }

            track.style.transform = `translateX(-${offset}px)`;

            // Update dots based on actual position
            dots.forEach((dot, index) => {
                dot.classList.toggle('lp-dot-active', index === currentIndex);
            });

            // Disable buttons at boundaries
            const slidesToShow = getSlidesToShow();
            const maxIndex = Math.max(0, totalSlides - slidesToShow);
            if (prevButton) prevButton.disabled = currentIndex === 0;
            if (nextButton) nextButton.disabled = currentIndex >= maxIndex;
            if (mobilePrevButton) mobilePrevButton.disabled = currentIndex === 0;
            if (mobileNextButton) mobileNextButton.disabled = currentIndex >= maxIndex;
        };

        const navigate = (direction) => {
            if (isTransitioning) return;
            
            const slidesToShow = getSlidesToShow();
            const maxIndex = Math.max(0, totalSlides - slidesToShow);
            
            // Prevent navigation beyond boundaries
            if (direction === 'next' && currentIndex >= maxIndex) return;
            if (direction === 'prev' && currentIndex === 0) return;
            
            isTransitioning = true;

            if (direction === 'next') {
                currentIndex++;
                updateSlider(true);
                setTimeout(() => {
                    isTransitioning = false;
                }, 400);
            } else if (direction === 'prev') {
                currentIndex--;
                updateSlider(true);
                setTimeout(() => {
                    isTransitioning = false;
                }, 400);
            }
        };

        // Desktop button event listeners
        if (prevButton) prevButton.addEventListener('click', () => {
            navigate('prev');
        });
        if (nextButton) nextButton.addEventListener('click', () => {
            navigate('next');
        });

        // Mobile button event listeners
        if (mobilePrevButton) mobilePrevButton.addEventListener('click', () => {
            navigate('prev');
        });
        if (mobileNextButton) mobileNextButton.addEventListener('click', () => {
            navigate('next');
        });

        // Dot navigation
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                if (isTransitioning) return;
                isTransitioning = true;
                currentIndex = index;
                updateSlider(true);
                setTimeout(() => {
                    isTransitioning = false;
                }, 400);
            });
        });

        // Touch/Swipe functionality for mobile
        const handleTouchStart = (e) => {
            if (isTransitioning) return;
            startX = e.touches[0].clientX;
            isDragging = true;
            track.style.transition = 'none';
            
            const allSlides = track.querySelectorAll('.lp-slide');
            const slideWidth = allSlides[0].offsetWidth;
            const computedStyle = window.getComputedStyle(track);
            const gap = parseInt(computedStyle.gap) || 0;
            startTransform = currentIndex * (slideWidth + gap);
        };

        const handleTouchMove = (e) => {
            if (!isDragging) return;
            currentX = e.touches[0].clientX;
            const diff = currentX - startX;
            track.style.transform = `translateX(-${startTransform - diff}px)`;
        };

        const handleTouchEnd = () => {
            if (!isDragging) return;
            isDragging = false;
            
            const diff = currentX - startX;
            const threshold = 50; // Minimum distance to trigger slide change
            
            if (Math.abs(diff) > threshold) {
                if (diff > 0) {
                    navigate('prev');
                } else {
                    navigate('next');
                }
            } else {
                updateSlider(true);
            }
            
            currentX = 0;
        };

        // Mouse drag functionality for desktop
        const handleMouseDown = (e) => {
            if (isTransitioning) return;
            startX = e.clientX;
            isDragging = true;
            track.style.cursor = 'grabbing';
            track.style.transition = 'none';
            
            const allSlides = track.querySelectorAll('.lp-slide');
            const slideWidth = allSlides[0].offsetWidth;
            const computedStyle = window.getComputedStyle(track);
            const gap = parseInt(computedStyle.gap) || 0;
            startTransform = currentIndex * (slideWidth + gap);
            
            e.preventDefault();
        };

        const handleMouseMove = (e) => {
            if (!isDragging) return;
            currentX = e.clientX;
            const diff = currentX - startX;
            track.style.transform = `translateX(-${startTransform - diff}px)`;
        };

        const handleMouseUp = () => {
            if (!isDragging) return;
            isDragging = false;
            track.style.cursor = 'grab';
            
            const diff = currentX - startX;
            const threshold = 50; // Minimum distance to trigger slide change
            
            if (Math.abs(diff) > threshold) {
                if (diff > 0) {
                    navigate('prev');
                } else {
                    navigate('next');
                }
            } else {
                updateSlider(true);
            }
            
            currentX = 0;
        };

        const handleMouseLeave = () => {
            if (isDragging) {
                handleMouseUp();
            }
        };

        // Add touch event listeners
        track.addEventListener('touchstart', handleTouchStart, { passive: true });
        track.addEventListener('touchmove', handleTouchMove, { passive: true });
        track.addEventListener('touchend', handleTouchEnd);

        // Add mouse event listeners
        track.addEventListener('mousedown', handleMouseDown);
        track.addEventListener('mousemove', handleMouseMove);
        track.addEventListener('mouseup', handleMouseUp);
        track.addEventListener('mouseleave', handleMouseLeave);

        // Set cursor style
        track.style.cursor = 'grab';

        // Handle window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Ensure currentIndex doesn't exceed maxIndex after resize
                const slidesToShow = getSlidesToShow();
                const maxIndex = Math.max(0, totalSlides - slidesToShow);
                if (currentIndex > maxIndex) {
                    currentIndex = maxIndex;
                }
                updateSlider(false);
            }, 150);
        });

        // Initial update
        updateSlider(false);
    });

    // Scroll to products functionality
    document.addEventListener('DOMContentLoaded', function() {
        const scrollButtons = document.querySelectorAll('.scroll-to-products');
        const targetSection = document.querySelector('.lp-comparison-container');

        scrollButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    });

    // Mobile scroll hint animation for product comparison
    document.addEventListener('DOMContentLoaded', function() {
        const scrollHint = document.getElementById('lp-scroll-hint-mobile');
        const comparisonGrid = document.querySelector('.lp-comparison-grid');
        
        if (!scrollHint || !comparisonGrid) return;

        // Initially hide the hint and pause animation until it's in viewport
        scrollHint.style.opacity = '0';
        scrollHint.style.pointerEvents = 'none';
        scrollHint.style.animationPlayState = 'paused';
        scrollHint.style.animation = 'none';

        let hasScrolled = false;
        let touchStartX = 0;
        let touchStartY = 0;
        let touchEndX = 0;
        let touchEndY = 0;
        let isVisible = false;
        let animationStartTime = null;

        // Hide hint after user scrolls
        const hideHint = function() {
            if (!hasScrolled) {
                hasScrolled = true;
                scrollHint.classList.add('hidden');
            }
        };

        // Show hint when it enters viewport and start animation
        const showHint = function() {
            if (!isVisible && !hasScrolled) {
                isVisible = true;
                scrollHint.style.opacity = '1';
                scrollHint.style.pointerEvents = 'auto';
                // Start the animation on the content only, not the overlay
                const swipeContent = scrollHint.querySelector('.lp-swipe-content');
                if (swipeContent) {
                    swipeContent.style.animation = 'lp-swipe-slide 3.5s cubic-bezier(0.4, 0, 0.2, 1) 3';
                }
                animationStartTime = Date.now();
                
                // Hide hint after all 3 animations complete (3 × 3.5s = 10.5s, add 0.5s buffer)
                setTimeout(function() {
                    if (!hasScrolled && isVisible) {
                        hideHint();
                    }
                }, 11000);
            }
        };

        // Hide hint when the overlay (hint background) is clicked
        scrollHint.addEventListener('click', function() {
            hideHint();
        });

        // Detect touch swipe on the comparison grid (only horizontal)
        comparisonGrid.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        comparisonGrid.addEventListener('touchmove', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            touchEndY = e.changedTouches[0].screenY;
            
            const deltaX = Math.abs(touchEndX - touchStartX);
            const deltaY = Math.abs(touchEndY - touchStartY);
            
            // Only hide if horizontal movement is greater than vertical (horizontal swipe)
            if (deltaX > 10 && deltaX > deltaY) {
                hideHint();
            }
        }, { passive: true });

        // Intersection Observer to detect when chart container is in viewport
        const comparisonContainer = document.querySelector('.lp-comparison-grid-wrapper');
        const targetElement = comparisonContainer || comparisonGrid;
        
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    showHint();
                }
            });
        }, {
            threshold: 0.1, // Trigger when 10% of chart is visible
            rootMargin: '0px'
        });

        if (targetElement) {
            observer.observe(targetElement);
        }

        // Pagination dots functionality
        const paginationDots = document.getElementById('lp-pagination-dots');
        const dots = paginationDots ? paginationDots.querySelectorAll('.lp-dot') : [];
        
        if (dots.length > 0 && comparisonGrid) {
            const cards = comparisonGrid.querySelectorAll('.lp-product-card');
            
            // Dot index = DOM order: dot 0 = first card, dot 1 = second, dot 2 = third
            function getDotIndexFromDomIndex(domIndex) {
                return domIndex;
            }
            
            // Start at the first card (first bullet)
            comparisonGrid.scrollLeft = 0;
            dots.forEach((dot, index) => {
                dot.classList.toggle('active', index === 0);
            });
            
            function updatePaginationDots() {
                if (!comparisonGrid || dots.length === 0 || cards.length === 0) return;
                
                const scrollLeft = comparisonGrid.scrollLeft;
                const containerPadding = 10; // padding from CSS
                const gap = 6; // gap between cards
                
                // Calculate which card is most visible (DOM index)
                let domIndex = 0;
                let maxVisible = 0;
                
                cards.forEach((card, index) => {
                    const cardRect = card.getBoundingClientRect();
                    const containerRect = comparisonGrid.getBoundingClientRect();
                    
                    // Calculate how much of the card is visible
                    const cardLeft = cardRect.left - containerRect.left;
                    const cardRight = cardRect.right - containerRect.left;
                    const visibleWidth = Math.min(cardRight, containerRect.width) - Math.max(cardLeft, 0);
                    
                    if (visibleWidth > maxVisible) {
                        maxVisible = visibleWidth;
                        domIndex = index;
                    }
                });
                
                // Map DOM index to dot index (dot 0 = first card, dot 1 = second, etc.)
                const dotIndex = getDotIndexFromDomIndex(domIndex);
                
                // Update dots
                dots.forEach((dot, index) => {
                    if (index === dotIndex) {
                        dot.classList.add('active');
                    } else {
                        dot.classList.remove('active');
                    }
                });
            }

            // Update dots on scroll with debounce for better performance
            let scrollTimeout;
            comparisonGrid.addEventListener('scroll', function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(updatePaginationDots, 50);
            }, { passive: true });
            
            // Initial update after a short delay to ensure layout is complete
            setTimeout(updatePaginationDots, 100);
        }
    });